import { Fragment } from 'react'

import { Event } from '~/utils/analytics/events'

import { logEvent } from '~/utils/analytics'

import styles from '~/shared/styles/Input.module.css'

import Spinner from './Spinner'
import { Icon } from './Icon'

export function Checkbox({
  centerText = false,
  className = '',
  disabled,
  gaEvents,
  id,
  isChecked,
  isLoading,
  labelClassName = '',
  onChange,
  text,
  checkboxClassName = 'border border-gray-placeholder h-6 w-6',
  checkboxOuterClassName = 'h-6 w-6',
  textSizeMobileView,
  textPosition = 'right',
  isBgWhite = false,
}: {
  centerText?: boolean
  className?: string
  disabled?: boolean
  gaEvents?: Event[]
  id: string
  isChecked: boolean
  isLoading?: boolean
  labelClassName?: string
  onChange: (value: boolean) => void
  text: string | React.ReactElement
  checkboxClassName?: string
  checkboxOuterClassName?: string
  textSizeMobileView?: 'large' | 'medium' | 'small' | 'extra-small'
  textPosition?: 'left' | 'right'
  isBgWhite?: boolean
}): React.ReactElement {
  const handleOnChange = (): void => {
    if (!disabled) {
      gaEvents?.forEach((event) => logEvent(event))
      onChange(!isChecked)
    }
  }

  const textSizeMobileViewClass = getTextSizeMobileViewClass(textSizeMobileView)

  return (
    <div className={`flex items-center relative ${centerText ? 'justify-center' : ''} ${className}`}>
      {textPosition === 'left' && (
        <label
          className={`flex items-center ${
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } ${textSizeMobileViewClass} md:text-sm ${centerText ? 'text-center' : ''} ${labelClassName}`}
          htmlFor={id}
        >
          {text}
        </label>
      )}

      <div
        className={`inline-block ${checkboxOuterClassName} ${textPosition === 'left' ? 'ml-auto' : 'mr-2'} relative`}
      >
        {isLoading ? (
          <Spinner color="purple" />
        ) : (
          <Fragment>
            <input
              checked={isChecked}
              className={`appearance-none bg-clip-content rounded-small inline-block checked:bg-purple ${
                disabled ? 'cursor-not-allowed' : 'cursor-pointer'
              } ${styles['input-checkbox']} ${isBgWhite ? styles['input-white-checkbox'] : ''} ${checkboxClassName}`}
              disabled={disabled}
              id={id}
              onChange={handleOnChange}
              type="checkbox"
            />
            {isChecked && <Icon className="text-sm text-white inset-center pointer-events-none" name="done" />}
          </Fragment>
        )}
      </div>

      {textPosition === 'right' && (
        <label
          className={`flex items-center ml-1 ${
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } ${textSizeMobileViewClass} md:text-sm ${centerText ? 'text-center' : ''} ${labelClassName}`}
          htmlFor={id}
        >
          {text}
        </label>
      )}
    </div>
  )
}

const getTextSizeMobileViewClass = (textSizeMobileView?: 'large' | 'medium' | 'small' | 'extra-small'): string => {
  switch (textSizeMobileView) {
    case 'large':
      return 'text-sm'
    case 'medium':
      return 'text-xs'
    case 'small':
      return 'text-xxs'
    default:
      return 'text-2.5'
  }
}
